import {request} from "./request";
import store from '../store/index'

// 获取文章类别列表
export function get_article_public_class_list(pagesize, page) {
    return request({
        url: '/hkt_admin/articlepublicclass/get_article_public_class_list',
        headers: {
          'token': store.state.token
        },
        params: {
            pagesize,
            page
        }
    })
}

// 删除文章类别
export function del_article_public_class(class_id) {
    return request({
        url: '/hkt_admin/articlepublicclass/del_article_public_class',
        headers: {
            'token': store.state.token
        },
        params: {
            class_id,
        }
    })
}

// 编辑文章类别
export function edit_article_public_class(class_id, name, is_show) {
    return request({
        url: '/hkt_admin/articlepublicclass/edit_article_public_class',
        headers: {
            'token': store.state.token
        },
        params: {
            class_id,
            name,
            is_show
        }
    })
}

// 添加文章类别
export function add_article_public_class(name, is_show) {
    return request({
        url: '/hkt_admin/articlepublicclass/add_article_public_class',
        headers: {
            'token': store.state.token
        },
        params: {
            name,
            is_show
        }
    })
}

// 获取文章列表
export function get_article_public_list(pagesize, page, title, class_id, admin_id, search_time, release_state) {
    return request({
        url: '/hkt_admin/articlepublic/get_article_public_list',
        headers: {
            'token': store.state.token
        },
        params: {
            pagesize,
            page,
            title,
            class_id,
            admin_id,
            search_time,
            release_state
        }
    })
}

// 修改文章
export function edit_article_public(data) {
    return request({
        url: '/hkt_admin/articlepublic/edit_article_public',
        method: 'post',
        headers: {
            'token': store.state.token,
            'Content-Type': 'multipart/form-data'
        },
        data: data
    })
}
// article_id	是	int	文章id
// title	是	string	标题
// content	是	string	内容
// release_state	是	int	发布状态
// abstract	否	string	摘要
// class_id	是	int	类别id
// image	否		图片
// label_id	否	string	标签id	逗号间隔加逗号
// -----------------------------------

// 添加文章
export function add_article_public(data) {
    return request({
        url: '/hkt_admin/articlepublic/add_article_public',
        method: 'post',
        headers: {
            'token': store.state.token,
            'Content-Type': 'multipart/form-data'
        },
        data: data
    })
}

// 文章发布
export function articleRelease(article_id, release_state) {
    return request({
        url: '/hkt_admin/articlepublic/article_public_release',
        headers: {
            'token': store.state.token
        },
        params: {
            article_id,
            release_state
        }
    })
}